import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "model/helpdesk/HelpdeskChamado";
import HelpdeskItemCompra from "model/helpdesk/HelpdeskItemCompra";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import HelpdeskChamadoService from "service/helpdesk/HelpdeskChamadoService";
import { converterDataHora } from "utils/convert";
import HelpdeskModalImagemTramite from "../helpdeskTramite/HelpdeskModalImagemTramite";
import HelpdeskTramiteCadastroModal from "../helpdeskTramite/HelpdeskTramiteCadastroModal";
import { InputTextarea } from "primereact/inputtextarea";

const helpdeskChamadoService = new HelpdeskChamadoService();

export default function HelpdeskChamadoCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    const [helpdeskChamado, setHelpdeskChamado] = useState<HelpdeskChamado>(new HelpdeskChamado());
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [titulo, setTitulo] = useState<string>('Tipo Chamado do Helpdesk');
    const [editando, setEditando] = useState<boolean>(false);
    const [tramiteSelecionado, setTramiteSelecionado] = useState<HelpdeskTramite | null>(null);
    const [visibleModalImage, setVisibleModalImage] = useState(false);
    const [visibleModalResposta, setVisibleModalResposta] = useState(false);

    const inputNomeRef = useRef<any>(null);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
        helpdeskChamadoService.getUsuarios().then(json => {
            setUsuarios(json);
        }).catch(e => {
            console.error(e);
        });
    }, [])

    useEffect(() => {
        console.log(helpdeskChamado);
    }, [helpdeskChamado])

    function validar() {

        if (!helpdeskChamado.descricao) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    function validarPersonalizado() {
        if (helpdeskChamado.status === 'FINALIZADO') {
            msgAlerta('Atenção', 'Chamado finalizado não pode ser alterado');
            return false;
        }
        return true;
    }

    const botoesExtra = <>
        {helpdeskChamado.status != "FINALIZADO" ? <Button label="Finalizar" style={{ marginLeft: 10 }}
            onClick={() => {
                startLoading();
                helpdeskChamadoService.finalizar(helpdeskChamado.id).then(() => {
                    consultar();
                    stopLoading();
                }).catch((e) => {
                    stopLoading();
                    console.error(e);
                    if (e && e.data && e.data.message) {
                        msgErro("Chamado", e.data.message);
                    } else {
                        msgErro("Chamado", 'Ocorreu um erro ao finalizar o Chamado, tente novamente!');
                    }
                    stopLoading();
                });
            }} /> : null}
    </>

    const consultar = () => {
        helpdeskChamadoService.consultar(helpdeskChamado.id)
            .then((data: HelpdeskChamado) => {
                setHelpdeskChamado(data);
            }).catch((e) => console.error(e));
    }

    return (

        <BaseCadastro model={helpdeskChamado} service={helpdeskChamadoService} validarPersonalizado={validarPersonalizado} botoesExtra={botoesExtra} setModel={(value: HelpdeskChamado) => setHelpdeskChamado(value)} validar={() => validar()} urlService="/helpdeskChamado" pathCadastro="/helpdeskChamado" tituloPagina={'Helpdesk Tipo Chamado'}>
            {visibleModalImage ? <HelpdeskModalImagemTramite visible={visibleModalImage} setVisible={(e) => setVisibleModalImage(e)} helpdeskTramite={tramiteSelecionado} /> : null}
            {visibleModalResposta ? <HelpdeskTramiteCadastroModal
                helpdeskChamado={helpdeskChamado}
                visible={visibleModalResposta}
                setVisible={(e) => setVisibleModalResposta(e)}
                onConfirm={() => {
                    consultar();
                }} /> : null}
            <TabView>
                <TabPanel header="Dados Gerais">
                    <div className="row">
                        <Label className="col col-sm-12">Descrição</Label>
                        <div className="col-sm-12">
                            <InputTextarea rows={3} disabled value={helpdeskChamado.descricao || ""} style={{ width: '100%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Status</Label>
                        <div className="col-sm-12">
                            <InputText disabled value={helpdeskChamadoService.getStatus(helpdeskChamado.status) || ""} style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Data Criação</Label>
                        <div className="col-sm-12">
                            <DatePicker
                                disabled
                                value={dayjs(helpdeskChamado.dataCriacao)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Tipo do Chamado</Label>
                        <div className="col-sm-12">
                            <InputText disabled value={helpdeskChamado.tipoChamado?.descricao || ""} style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Prioridade</Label>
                        <div className="col-sm-12">
                            <Dropdown
                                onChange={(e) => setHelpdeskChamado({ ...helpdeskChamado, prioridade: e.target.value })}
                                value={helpdeskChamado.prioridade}
                                disabled={helpdeskChamado.status == "FINALIZADO"}
                                optionValue="value"
                                optionLabel="label"
                                options={helpdeskChamadoService.getPrioridadeLista()}
                                style={{ width: '15%' }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Usuário do Cliente/Solicitante</Label>
                        <div className="col-sm-12">
                            <InputText disabled value={helpdeskChamado.usuarioCliente?.nome || ""} style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Nome do Solicitante</Label>
                        <div className="col-sm-12">
                            <InputText disabled value={helpdeskChamado.nomeSolicitante || ""} style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Cliente</Label>
                        <div className="col-sm-12">
                            <InputText disabled value={helpdeskChamado.cliente?.nome || ""} style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Usuario Atendente</Label>
                        <div className="col-sm-12">
                            <Dropdown
                                onChange={(e) => setHelpdeskChamado({ ...helpdeskChamado, usuarioAtendente: e.target.value })}
                                value={helpdeskChamado.usuarioAtendente || ""}
                                disabled={helpdeskChamado.status == "FINALIZADO"}
                                optionLabel="nome"
                                dataKey="id"
                                options={usuarios}
                                filter
                                style={{ width: '25%' }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <Label className="col col-sm-12">Usuário Finalizado</Label>
                        <div className="col-sm-12">
                            <InputText disabled value={helpdeskChamado.usuarioFinalizado?.nome || ""} style={{ width: '50%' }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <BaseDataTableEdit
                                showDelete={false}
                                showEdit={false}
                                addButtonDisabled
                                tituloLista="Itens Compra"
                                getNewModel={() => new HelpdeskItemCompra()}
                                dataKey="key"
                                lista={helpdeskChamado.itensCompra ? helpdeskChamado.itensCompra : []}
                                setLista={(value: any) => setHelpdeskChamado({ ...helpdeskChamado, itensCompra: value })}
                                scrollable
                                scrollHeight='500px'
                            >
                                <Column field="sequencial" header="Seq" style={{ width: '10%' }} />
                                <Column field="produto.nome" header="Produto" />
                            </BaseDataTableEdit>
                        </div>
                    </div>

                </TabPanel>
                <TabPanel header="Trâmites" >
                    <div className="row">
                        <div className="col-sm-12">
                            <DataTable
                                selection={tramiteSelecionado!}
                                onSelectionChange={(e) => setTramiteSelecionado(e.value as HelpdeskTramite)}
                                selectionMode="single"
                                header="Trâmites"
                                dataKey="id"
                                value={helpdeskChamado.tramites ? helpdeskChamado.tramites : []}
                                scrollable
                                scrollHeight='500px'
                                onRowDoubleClick={(e) => { setVisibleModalImage(true) }}
                                emptyMessage="Nenhum registro encontrado"
                            >
                                <Column field="resposta" header="Resposta" />
                                <Column field="data" header="Data" body={(rowData) => converterDataHora(rowData.data)} />
                            </DataTable>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <Button label="Responder" style={{ marginRight: 30 }} onClick={() => {
                                setVisibleModalResposta(true);
                            }} />
                        </div>
                    </div>
                </TabPanel>
            </TabView>

        </BaseCadastro>
    )
}